import store from "@/js/store";

import {
	locationSplittingIsNewFeatureForUser,
	findEmailIsNewFeatureForUser,
	isFiltersMovedToLeadsList,
	isExistingUserBeforeDomainChange
} from "@/js/services/ApiVersionService";

const getRemindersList = async () => {
	await store.dispatch("getReminders");
}

export const changeReminderStatus = async (type, isActive, payload = {}) => {
	await store.dispatch("changeReminderStatus", {
		reminderType: type,
		active: isActive,
		...payload
	});
};

const createNewReminder = async (type) => {
	await changeReminderStatus(type, true);
};

export const getReminderByType = (type) => {
	const remindersList = store.getters.remindersArr;

	return remindersList.find((v) => v.reminderType === type);
};

const isReminderExist = (type) => {
	return !!getReminderByType(type);
};

export const checkAndCreateReminder = async (type, additionalCondition = true) => {
	if (!isReminderExist(type) && additionalCondition) {
		await createNewReminder(type);
	}
};

export const checkCreateAndGetReminderByType = async (type) => {
	await checkAndCreateReminder(type);

	return getReminderByType(type);
}

export const initReminders = async () => {
	await getRemindersList();

	await checkAndCreateReminder("FIND_EMAIL_FEATURE_REMINDER", findEmailIsNewFeatureForUser());
	await checkAndCreateReminder("CITY_COUNTRY_FIELDS", locationSplittingIsNewFeatureForUser());
	await checkAndCreateReminder("LEAD_LIST_FILTERS", isFiltersMovedToLeadsList());
	await checkAndCreateReminder("DOMAIN_MIGRATION", isExistingUserBeforeDomainChange());
	await checkAndCreateReminder("G2_REVIEW");
};

export const isReminderEnabled = (type) => {
	return isReminderExist(type) && getReminderByType(type).active;
};

export const isG2ReminderEnabled = () => {
	const g2Reminder = getReminderByType("G2_REVIEW");
	const timeToShowReminder = !g2Reminder.remindAt || new Date(g2Reminder.remindAt).getTime() < Date.now();

	return isReminderEnabled("G2_REVIEW") && timeToShowReminder && store.getters.subscription;
};
